<template>
<div class="unitConfiguration">
  <box ref="box"></box>
  <el-card shadow="never" :style="style">
    <div class="line">
      <span class="queryInfo">{{ $t('recentQuery') }} {{ updateTime }}</span>
      <el-button class="queryBtn" type="primary" :loading="searching" @click="_getConfig">{{$t('queryButton')}}</el-button>
    </div>
    <div class="settingContent">
        <span v-for="(item, index) in settingList" :key="index" class="text item name">
          {{ $t(item.name) }}
        </span>
    </div>
    <div class="settingContent">
        <span v-for="(item, index) in settingList" :key="index" class="text item">
          {{item.count}}
        </span>
    </div>
  </el-card>
</div>
</template>

<script>
import Box from "@/components/Box";
import {getConfigCache, getConfig} from "@/api/query"
import {formatDate} from "assets/utils";
import Status from "components/Status";
export default {
  name: "unitConfiguration",
  mixins: [Status],
  components: {
    Box
  },
  data() {
    return {
      bottomHeight: null,
      style: null,
      updateTime: '',
      settingList: [
        {
          name: 'loopboard',
          count: null
        },
        {
          name: 'multiline',
          count: null
        },
        {
          name: 'busline',
          count: null
        },
        {
          name: 'gasExtinguishing',
          count: null
        },
        {
          name: 'broadcast',
          count: null
        },
        {
          name: 'eventRecord',
          count: null
        },
        {
          name: 'crt',
          count: null
        },
        {
          name: 'gateway',
          count: null
        },
        {
          name: 'gprs',
          count: null
        },
        {
          name: 'wifi',
          count: null
        },
        {
          name: 'serial',
          count: null
        },
        {
          name: 'interfaceCard',
          count: null
        }
      ],
      searching: false
    }
  },
  mounted() {
    this.calcHeight()
    // this._getConfigCache()
  },
  computed: {
    controllInfo() {
      return this.$store.state.controlInfo
    }
  },
  methods: {
    calcHeight() {
      setTimeout(() => {
        this.bottomHeight = this.$refs.box.$el.clientHeight + 'px'
        this.style = `height: calc(100vh - 100px - ${this.bottomHeight})`
      }, 20)
    },
    _getConfigCache() {
      getConfigCache({controllerPsn: this.controllInfo.controllerPsn}).then((res) => {
        if (res.data) {
          this.settingList[0].count = res.data.loopboard // 回路板卡
          this.settingList[1].count = res.data.multiline // 多线控制盘
          this.settingList[2].count = res.data.busline // 总线控制盘
          this.settingList[3].count = res.data.gasExtinguishing // 气体灭火器
          this.settingList[4].count = res.data.broadcast // 总线广播盘
          this.settingList[5].count = res.data.eventRecord // 事件记录器
          this.settingList[6].count = res.data.crt // 图形显示装置
          this.settingList[7].count = res.data.gateway // 传输设备
          this.settingList[8].count = res.data.gprs // GRPS
          this.settingList[9].count = res.data.wifi // WIFI
          this.settingList[10].count = res.data.serial // 串口调试
          this.settingList[11].count = res.data.interfaceCard // 接口卡
        }
      })
    },
    _getConfig() {
      this.searching = true
      this.show()
      this.updateTime = formatDate(new Date())
      getConfig({controllerPsn: this.controllInfo.controllerPsn}).then((res) => {
        if (res.data) {
          this.settingList[0].count = res.data.loopboard
          this.settingList[1].count = res.data.multiline
          this.settingList[2].count = res.data.busline
          this.settingList[3].count = res.data.gasExtinguishing
          this.settingList[4].count = res.data.broadcast
          this.settingList[5].count = res.data.eventRecord
          this.settingList[6].count = res.data.crt
          this.settingList[7].count = res.data.gateway
          this.settingList[8].count = res.data.gprs
          this.settingList[9].count = res.data.wifi
          this.settingList[10].count = res.data.serial
          this.settingList[11].count = res.data.interfaceCard
          this.success(res.message ? res.message : '操作成功')
          this.searching = false
        }
      }).catch(() => {
        this.failed()
        this.searching = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.unitConfiguration{
  width: 100%;
  height: 100%;
  .el-card {
    margin-bottom: 10px;
    .el-card__header {
      span {
        font-size: 16px;
        font-family: Microsoft YaHei,serif !important;
        color: #2F4E68;
        font-weight: bold;
      }
      .clearfix:before,
      .clearfix:after {
        display: table;
        content: "";
      }
      .clearfix:after {
        clear: both
      }
    }
    .el-card__body {
      padding: 10px !important;
      .line{
        margin-bottom: 10px;
        &:after{
          content: '';
          clear: both;
          display: table;
        }
        .queryInfo{
          padding: 0 10px;
          color: #B3BBC1;
          font-size: 12px;
        }
        .queryBtn{
          width: 90px;
          float: right;
        }
      }

      .settingContent {
        .name{
          padding: 10px 0;
          background-color: #f5f7fa;
        }
        .text {
          font-size: 12px;
          font-family: Microsoft YaHei,serif !important;
          color: #646464;
        }
        .item {
          margin-bottom: 8px;
          display: inline-block;
          width: 8.3%;
          text-align: center;
        }
      }
    }
  }
}
</style>
